/* eslint-disable array-callback-return */
/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import ReactPixel from 'root/lib/react-facebook-pixel';
import isBrowser from 'utils/isBrowser';

export function init(codes) {
  if (isBrowser() && !window.FB_INITIALIZED) {
    codes.filter((v) => !v.name || v.name === 'fbPixel').map((v) => {
      ReactPixel.init(v.codeId || v);
    });
  }
}

export function pageview() {
  ReactPixel.pageView();
}

export function event(name = '', data = {}) {
  if (name) {
    ReactPixel.event(event, data);
  }
}

export function exception(description = '', fatal = false) {
  if (description) {
    ReactPixel.trackCustom('Error', { description, fatal });
  }
}

export function trackSingleCustom(code, name, data = {}) {
  if (code && name) {
    // eslint-disable-next-line no-undef
    ReactPixel.trackSingleCustom(code, name, data);
  }
}
